///////////////////////////////////////////////////////////////////////////////
// Copyright (C) 2002-2026, Open Design Alliance (the "Alliance").
// All rights reserved.
//
// This software and its documentation and related materials are owned by
// the Alliance. The software may only be incorporated into application
// programs owned by members of the Alliance, subject to a signed
// Membership Agreement and Supplemental Software License Agreement with the
// Alliance. The structure and organization of this software are the valuable
// trade secrets of the Alliance and its suppliers. The software is also
// protected by copyright law and international treaty provisions. Application
// programs incorporating this software must include the following statement
// with their copyright notices:
//
//   This application incorporates Open Design Alliance software pursuant to a
//   license agreement with Open Design Alliance.
//   Open Design Alliance Copyright (C) 2002-2026 by Open Design Alliance.
//   All rights reserved.
//
// By use of this software, its documentation or related materials, you
// acknowledge and accept the above terms.
///////////////////////////////////////////////////////////////////////////////

import type { IViewer } from "../viewer/IViewer";
import { FileSource, ILoader, ILoaderProvider, ILoadersRegistry } from "./ILoader";

class Loaders implements ILoadersRegistry {
  private readonly _providers = new Map<string, ILoaderProvider>();

  registerLoader(name: string, provider: ILoaderProvider): void {
    this._providers.set(name, provider);
  }

  getLoader(name: string): ILoaderProvider | undefined {
    return this._providers.get(name);
  }

  getLoaders(): Map<string, ILoaderProvider> {
    const map = new Map<string, ILoaderProvider>();
    this._providers.forEach((value, key) => map.set(key, value));
    return map;
  }

  createLoader(viewer: IViewer, file: FileSource, format?: string): ILoader | null {
    let result: ILoader = null;
    this._providers.forEach((provider, key) => {
      const loader = provider(viewer);
      if (loader.isSupport(file, format)) {
        result = loader;
        result.name = key;
      }
    });
    return result;
  }
}

const _loaders = new Map<string, Loaders>();

function loadersRegistry(viewerType = ""): ILoadersRegistry {
  let result = _loaders.get(viewerType);
  if (!result) {
    result = new Loaders();
    _loaders.set(viewerType, result);
  }
  return result;
}

export { loadersRegistry };
